import { Box } from '@mui/material';
import { trackOutboundLink } from '@/utils/analytics';

const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.calorium&pcampaignid=web_share';
const APP_STORE_URL =
  'https://apps.apple.com/us/app/calorium-ai-food-journal/id6746070838';

export const AppStoreButtons = () => {
  const handleAppStoreClick = () => {
    trackOutboundLink(APP_STORE_URL, 'App Store');
  };

  const handleGooglePlayClick = () => {
    trackOutboundLink(GOOGLE_PLAY_URL, 'Google Play');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      <Box
        component="a"
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleAppStoreClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: { xs: 56, sm: 60, md: 64 },
          transition: 'transform 0.2s ease',
          '&:hover': {
            transform: 'scale(1.05)',
          },
        }}
      >
        <Box
          component="img"
          src="/appstore.svg"
          alt="Download on the App Store"
          sx={{
            height: '100%',
            width: 'auto',
            maxWidth: '100%',
          }}
        />
      </Box>

      <Box
        component="a"
        href={GOOGLE_PLAY_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleGooglePlayClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: { xs: 56, sm: 60, md: 64 },
          transition: 'transform 0.2s ease',
          '&:hover': {
            transform: 'scale(1.05)',
          },
        }}
      >
        <Box
          component="img"
          src="/googleplay.svg"
          alt="Get it on Google Play"
          sx={{
            height: '100%',
            width: 'auto',
            maxWidth: '100%',
          }}
        />
      </Box>
    </Box>
  );
};
